import React, { ReactElement, ReactNode } from "react";

interface Children {
  children: ReactNode;
}

interface FormFieldProps extends Children {
  shadow?: boolean;
  style?: any;
  className?: string;
}

export const FormField = ({ children, style, className }: FormFieldProps) => (
  <div style={{ ...styles.formField, ...style }} className={className}>
    {children}
  </div>
);

const styles = {
  formContainer: {
    flex: 1,
    justifyContent: "center",
  },
  formField: {
    border: "1px solid rgba(120, 120, 128, 0.16)",
    borderRadius: 10,
    backgroundColor: "white",
  },
  longShadow: {
    shadowOpacity: 0.12,
    shadowColor: "black",
    shadowOffset: { width: 0, height: 3 },
    shadowRadius: 8,
  },
  shortShadow: {
    shadowOpacity: 0.04,
    shadowColor: "black",
    shadowOffset: { width: 0, height: 3 },
    shadowRadius: 1,
  },
};

FormField.defaultProps = {
  shadow: false,
  style: undefined,
};
